import ITheme from "@/interfaces/iTheme";
import backgroundImageDarkTheme from "@assets/themes/dark/backgroundImageDarkTheme.svg";

export class DarkTheme implements ITheme
{
    static Id = 'dark';
    id = DarkTheme.Id;

    name = 'Dark';

    colors = {
        application: '#041335',
        text: '#E0E0E0',
        confirm: '#041335',
        secondary: '#62B4E4',

        // Challenge card colors
        solved: '#767676',
        locked: '#0009',
        unsolved: '#0071BC',
        noMoreAttempts: '#572b34',
        disabled: '#572b34',

        windowBackground: '#0009',
        windowText: '#FFF',
        windowBorder: '#FFFFFF1F',

        tag: '#62B4E4',
        activeTab: '#62B4E4',
        dialogText: '#303030',
        dialogLink: '#041335',
        dialogSuccessText: '#4CAF50',
        dialogFailureText: '#F44336',
        dialogIcon: '#553A97',
        success: '#4CAF50',
        warning: '#FF9800',

        // Table
        tableHeaderActionButtons: 'white',
        tableHeaderSelectAllButtons: '#62B4E4',

        //settings and bulk select checkboxes 
        checkedFill: '#0071BC',
        settingsInputError: '#D73C3C',
        settingsInputErrorShadow: '#010309',

        // focus indicators
        focusVisibleIndicator:  '#0071BC',

        // the most common color from the background image with sufficient contrast
        backgroundImageColor: '#031133',

        actionButtonBackground: '#031133',
        actionButtonText: 'white',
    };

    fontFamily = "Blinker";
    landingFontFamily = "space_frigate";
    backgroundImage = backgroundImageDarkTheme;
    isDark = true;
}
